//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            activeFaqs: {},
            loading: false,
            faqs: [],
            sorting: '',
            pagination: {},
            publishDialogVisible: false
        };
    },

    computed: {
        params () {
            let params = {};

            params.sort = 'title|desc';
            if (this.sorting !== '' && this.sorting !== 'null|asc') {
                params.sort = this.sorting;
            }

            params.limit = this.pagination.perPage;
            params.page = this.pagination.currentPage;

            return params;
        }
    },

    mounted () {
        this.init();
    },

    methods: {
        async init () {
            try {
                this.loading = true;
                await this.loadFaqs();
            } catch (error) {
                this.$message({
                    type: 'error',
                    message: this.$lang.get('std.ajaxError')
                });
            } finally {
                this.loading = false;
            }
        },
        loadFaqs () {
            return new Promise((resolve, reject) => {
                axios.get('faqs', {
                    params: this.params
                }).then(response => {
                    this.faqs = response.data.data;
                    this.pagination = this.$helper.getPaginationData(response);
                    resolve();
                }).catch(() => reject());
            });
        },
        async goToPage (page) {
            this.pagination.currentPage = page;

            try {
                this.loading = true;
                await this.loadFaqs();
            } catch (error) {
                this.$message({
                    type: 'error',
                    message: this.$lang.get('std.ajaxError')
                });
            } finally {
                this.loading = false;
            }
        },
        async sortTable (data) {
            let order = 'asc';
            if (data.order === 'descending') {
                order = 'desc';
            }

            this.sorting = data.prop + '|' + order;

            try {
                this.loading = true;
                await this.loadFaqs();
            } catch (error) {
                this.$message({
                    type: 'error',
                    message: this.$lang.get('std.ajaxError')
                });
            } finally {
                this.loading = false;
            }
        },
        deleteConfirmPrompt (row) {
            this.$confirm(this.$lang.get('models.faqs.delete.text'), this.$lang.get('models.faqs.delete.confirm'), {
                confirmButtonText: this.$lang.get('std.delete'),
                cancelButtonText: this.$lang.get('std.cancel'),
                type: 'warning'
            }).then(() => {
                this.deleteFaqs(row);
            }).catch(() => {});
        },
        deleteFaqs (row) {
            axios.delete('faqs/' + row.id).then(async response => {
                try {
                    this.loading = true;
                    await this.loadFaqs();

                    this.$message({
                        type: 'success',
                        message: response.data.message
                    });
                } catch (error) {
                    this.$message({
                        type: 'error',
                        message: this.$lang.get('std.ajaxError')
                    });
                } finally {
                    this.loading = false;
                }
            }).catch(() => {});
        },
        publishConfirmPrompt (row) {
            this.$set(this.activeFaqs, 'id', row.id ? row.id : undefined);
            this.$set(this.activeFaqs, 'title', row.title ? row.title : '');
            this.$set(this.activeFaqs, 'content', row.content ? row.content : '');
            this.$set(this.activeFaqs, 'published', row.published ? row.published : false);
            this.$set(this.activeFaqs, 'published_at', row.published_at ? this.$helper.getDate(row.published_at) : moment());
            this.publishDialogVisible = true;
        },
        publishFaqs () {
            if (!this.activeFaqs.published_at) {
                this.activeFaqs.published_at = moment();
            }

            this.activeFaqs.published = true;
            this.activeFaqs.published_at = moment.utc(this.activeFaqs.published_at).format('YYYY-MM-DD HH:mm:ss');
            let message = this.isInFuture(this.activeFaqs.published_at) ? this.$lang.get('models.faqs.tobe-published') : this.$lang.get('models.faqs.published');

            axios({
                method: 'put',
                url: `faqs/${this.activeFaqs.id}`,
                data: this.activeFaqs
            }).then(async response => {
                try {
                    this.loading = true;
                    await this.loadFaqs();

                    this.$message({
                        type: 'success',
                        message: message
                    });
                } catch (error) {
                    this.$message({
                        type: 'error',
                        message: this.$lang.get('std.ajaxError')
                    });
                } finally {
                    this.loading = false;
                    this.publishDialogVisible = false;
                }
            }).catch(() => {});
        },
        unpublishConfirmPrompt (row) {
            this.$confirm(this.$lang.get('models.faqs.unpublish.text'), this.$lang.get('models.faqs.unpublish.confirm'), {
                confirmButtonText: this.$lang.get('models.faqs.unpublish.confirm'),
                cancelButtonText: this.$lang.get('std.cancel'),
                type: 'warning'
            }).then(() => {
                this.unpublishFaqs(row);
            }).catch(() => {});
        },
        unpublishFaqs (row) {
            axios.put(`faqs/${row.id}/unpublish`).then(async response => {
                try {
                    this.loading = true;
                    await this.loadFaqs();

                    this.$message({
                        type: 'success',
                        message: response.data.message
                    });
                } catch (error) {
                    this.$message({
                        type: 'error',
                        message: this.$lang.get('std.ajaxError')
                    });
                } finally {
                    this.loading = false;
                }
            }).catch(() => {});
        },
        isInFuture (date) {
            let now = moment().utc();
            let utcDate = moment.utc(date, 'YYYY-MM-DD HH:mm:ss');

            return moment(now).isBefore(utcDate);
        }
    }
};
